import { connect } from 'react-redux'
import { startTicker } from '../../actions/intervalTasks'

export default connect(null, { startTicker })

